/**
 * @file text-color-labels.ts
 * @description Подписи ролей цвета текста в кабинете (phase19.16, партия
 * SB120, этап 3а; uiux-sb120-fields §3): ячейки `ColorField mode="text"` у
 * шапки раздела, текста на фото фона и частей элемента (`typo.<часть>.color`).
 *
 * С секции v4 подписи ролей текста живут в кабинете (прежние
 * `TEXT_COLOR_ROLE_OPTIONS` shared — @deprecated, только для подъёма v3).
 * Реестр по `SITE_TEXT_COLOR_ROLES`: новая роль текста без подписи здесь —
 * ошибка tsc.
 */

import type { SiteTextColorRole } from "@chaiberi/shared";

/** Роль текста → подпись ячейки. */
export const TEXT_COLOR_ROLE_LABELS: Readonly<Record<SiteTextColorRole, string>> = {
  text: "Текст",
  textMuted: "Второй текст",
  accent: "Акцент",
  onDark: "На тёмном",
};
